var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128abc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.96,26.135c-3.753,3.495-21.83,21.621-23.706,48.97c-0.061,1.055-0.098,2.097-0.123,3.14 H72.935c-0.159,0-0.307,0.024-0.466,0.049C73.904,51.362,94.581,29.484,120.96,26.135z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.934,30.833v47.413h-21.658c0.012-0.883,0.037-1.766,0.098-2.637 C105.017,51.203,121.316,34.291,124.934,30.833z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.724,78.245h-21.658V30.82c3.606,3.458,19.917,20.371,21.56,44.788 C152.687,76.479,152.712,77.362,152.724,78.245z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.531,78.294c-0.159-0.025-0.307-0.049-0.466-0.049h-24.197 c-0.025-1.042-0.061-2.085-0.123-3.14c-1.876-27.336-19.941-45.475-23.706-48.97C161.419,29.484,182.096,51.362,183.531,78.294z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.519,84.328c-1.484,27.312-22.762,49.436-49.694,52.257c0.307-0.172,0.601-0.38,0.846-0.662 c14.754-16.838,22.799-34.143,24.037-51.545h24.356C183.225,84.377,183.372,84.353,183.519,84.328z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.175,136.585c-26.932-2.821-48.21-24.945-49.694-52.257c0.147,0.025,0.294,0.049,0.454,0.049 h24.356c1.239,17.403,9.284,34.707,24.037,51.545C121.574,136.205,121.868,136.413,122.175,136.585z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.934,84.377v46.309c-13.061-15.269-20.26-30.807-21.486-46.309H124.934z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.552,84.377c-1.226,15.502-8.425,31.04-21.487,46.309V84.377H152.552z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.019,68.066v86.976l-39.711,51.84c-0.773,0.993-4.501,6.586-3.888,22.603l-41.98,0.38 l0.037-37.798c0-13.907,16.838-23.902,17.01-24.001c0.049-0.037,0.11-0.074,0.159-0.11c8.56-5.727,18.028-15.404,18.482-15.87 l15.821-17.145c3.532-3.826,8.082-5.985,11.822-5.985c1.864,0,3.52,0.54,4.758,1.668c1.582,1.472,1.987,3.532,2.048,5.004 c0.159,3.839-1.717,8.266-5.016,11.847l-22.222,24.074c-1.153,1.239-1.079,3.189,0.172,4.329c1.239,1.153,3.189,1.067,4.329-0.172 l22.235-24.074c4.378-4.746,6.856-10.817,6.635-16.262c-0.159-3.765-1.545-6.966-4.035-9.259c-1.312-1.202-2.858-2.073-4.538-2.6 v-55.31c-0.037-5.96,3.728-10.657,8.572-10.682h0.037C222.825,57.519,226.982,62.253,227.019,68.066z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.579,229.484c0.613-16.005-3.115-21.609-3.9-22.603l-39.698-51.84V68.09 c0.037-5.838,4.182-10.572,9.259-10.572h0.037c4.857,0.025,8.622,4.722,8.585,10.694v55.298c-1.68,0.527-3.225,1.398-4.55,2.6 c-3.164,2.919-4.538,7.297-3.875,12.325c0.613,4.636,2.919,9.321,6.5,13.196l22.222,24.074c1.153,1.239,3.091,1.325,4.329,0.172 c1.251-1.141,1.324-3.091,0.184-4.329l-22.235-24.074c-2.686-2.919-4.476-6.5-4.918-9.836c-0.392-3.005,0.294-5.494,1.95-7.015 c0.491-0.454,1.067-0.809,1.68-1.079c0.503,0.356,1.116,0.564,1.778,0.564c0.944,0,1.791-0.417,2.355-1.092 c3.52,0.356,7.567,2.453,10.768,5.924l15.882,17.206c0.392,0.405,9.86,10.081,18.408,15.808c0.061,0.037,0.11,0.074,0.172,0.098 c0.172,0.11,16.998,10.105,16.998,24.013l0.049,37.798L72.579,229.484z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.0fdc7d9d2b569da640645460ceb6a675.svg";
export { ForwardRef as ReactComponent };